import React from "react";
import PropTypes from "prop-types";

import copy from "../../data/copy.js";

const CabinetCopy = ({ section, languageId }) => {
  return (
    <div className={languageId != "en" ? "right-to-left" : ""}>
      {copy[languageId].cabinet[section].map((paragraph, idx) => {
        if (paragraph.type === "highpoint")
          return (
            <div
              key={idx}
              className="highpoint"
              dangerouslySetInnerHTML={{ __html: paragraph.text }}
            />
          );
        if (paragraph.type === "h2") return <h2 key={idx}>{paragraph.text}</h2>;
        if (paragraph.type === "h2-right")
          return (
            <h2 key={idx} className="h2-right">
              {paragraph.text}
            </h2>
          );
        if (paragraph.type === "i")
          return (
            <h3 key={idx}>
              <i>{paragraph.text}</i>
            </h3>
          );
        if (paragraph.type === "video") {
          return (
            <div key={idx} className="video">
              <iframe
                src={paragraph.src}
                width="640"
                height="360"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          );
        }
        if (paragraph.type === "img") {
          return (
            <div key={idx}>
              <img src={paragraph.src} />
              {paragraph.caption && (
                <p className="img-caption">{paragraph.caption}</p>
              )}
            </div>
          );
        }
        if (paragraph.type === "text-right")
          return (
            <p
              key={idx}
              className="text-right"
              dangerouslySetInnerHTML={{ __html: paragraph.text }}
            />
          );
        return (
          <p key={idx} dangerouslySetInnerHTML={{ __html: paragraph.text }} />
        );
      })}
    </div>
  );
};

CabinetCopy.propTypes = {
  languageId: PropTypes.string,
  section: PropTypes.string
};

export default CabinetCopy;



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/CabinetCopy.jsx